module.exports = __webpack_public_path__ + "media/images/case-studies/jindivick-214c887aa6b0b7e41da595b40d3d8395.jpg";